import { render, staticRenderFns } from "./CreateTemplate.yaml?vue&type=template&id=3e609cde&component"
import script from "./CreateTemplate.yaml?vue&type=script&lang=ts&component"
export * from "./CreateTemplate.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports